export const APP_NAME = 'Dr Family';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const LIMIT_ITEMS = 10;
export const LIMIT_ITEMS_ON_MODAL = 5;
// export const REMOTE_CONFIG_CACHE = 100;
export const REMOTE_CONFIG_CACHE = 3600000;
